import { createSelector } from '@ngrx/store';
import { getSelfDisclosureState as state } from '../reducers';
import { SelfDisclosureState } from './self-disclosure.reducers';

export const getSelfDisclosureModel = createSelector(
  state,
  (state: SelfDisclosureState) => state.selfDisclosureModel
);
export const getSelfDisclosureResponses = createSelector(
  state,
  (state: SelfDisclosureState) => state.selfDisclosureResponses
);
export const getLoadModelActionState = createSelector(
  state,
  (state: SelfDisclosureState) => state.loadModelActionState
);
export const getSaveSelfDisclosureAnswersActionState = createSelector(
  state,
  (state: SelfDisclosureState) => state.saveAnswersActionState
);
export const getLoadResponsesActionState = createSelector(
  state,
  (state: SelfDisclosureState) => state.loadResponsesActionState
);
export const getSelfDisclosurePropertySearcher = createSelector(
  state,
  (state: SelfDisclosureState) => state.propertySearcher
);
